import { render } from "./MessageSingle.vue?vue&type=template&id=371e7f5f&scoped=true&ts=true"
import script from "./MessageSingle.vue?vue&type=script&lang=ts"
export * from "./MessageSingle.vue?vue&type=script&lang=ts"

import "./MessageSingle.vue?vue&type=style&index=0&id=371e7f5f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-371e7f5f"]])

export default __exports__